var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-img',{staticClass:"rounded-circle",staticStyle:{"object-fit":"cover"},attrs:{"width":"50","height":"50","src":_vm.imgSrc,"alt":"logo"}})}
var staticRenderFns = []

export { render, staticRenderFns }